"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTagFilter = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

/**
 * A filter function factory that filters offers based on their Thundercorp tags
 * by default, and optionally allows defining a custom filter for a given filter
 * type. Supports multiple filters (combined as AND), and each filter can have
 * multiple active options (combined as OR).
 *
 * @param {object=}       activeFilters an object where keys are the filter names, and values are arrays of selected options for the given filter
 * @param {object=}       customFilters an object where keys are the filter names, and values are functions taking two arguments - active values for the filter, and the current offer - and returns a boolean for whether the offer passed the filter
 * @param {string="tags"} tagsKey       the name of the tags field for the type of offer being filtered (it's probably just tags)
 * @returns {function(*=):boolean} a function to be passed to `Array.prototype.filter` when iterating over offers
 */
var createTagFilter = function createTagFilter() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$activeFilters = _ref.activeFilters,
      activeFilters = _ref$activeFilters === void 0 ? {} : _ref$activeFilters,
      _ref$customFilters = _ref.customFilters,
      customFilters = _ref$customFilters === void 0 ? {} : _ref$customFilters,
      _ref$tagsKey = _ref.tagsKey,
      tagsKey = _ref$tagsKey === void 0 ? 'tags' : _ref$tagsKey;

  return function (offer) {
    return Object.entries(activeFilters).every(function (_ref2) {
      var _offer$tagsKey;

      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
          _ref3$ = _ref3[0],
          activeName = _ref3$ === void 0 ? '' : _ref3$,
          _ref3$2 = _ref3[1],
          activeValues = _ref3$2 === void 0 ? [] : _ref3$2;

      return customFilters[activeName] != null ? customFilters[activeName](activeValues, offer) : (_offer$tagsKey = offer[tagsKey]) === null || _offer$tagsKey === void 0 ? void 0 : _offer$tagsKey.some(function (_ref4) {
        var name = _ref4.name,
            value = _ref4.value;
        return name === activeName && activeValues.includes(value);
      });
    });
  };
};

exports.createTagFilter = createTagFilter;
//# sourceMappingURL=filter.js.map